module.exports = __webpack_public_path__ + "media/theme/1 open-50827133.png";